// @core/api/endpoints/subscription/list_bundle_subscriptions.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListBundleSubscriptionsResponse,
} from '../../../types/subscription';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/subscription';

/**
 * List tenant's bundle subscriptions
 * Returns all bundle subscriptions for a tenant with their status and included products.
 */
export async function ListBundleSubscriptions(
  tenant_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListBundleSubscriptionsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/tenants/:tenant_id/bundle-subscriptions`;
  requestPath = requestPath.replace(':tenant_id', encodeURIComponent(tenant_id));
  const requestOptions = options;
  return client.get<ListBundleSubscriptionsResponse>(requestPath, { ...requestOptions, params });
}
